<div class="position-reletivediv popup-inner-space">
    <div class="betweenheader">Custom Report Configuration</div>

    <div class="text-right flow-right">
        <img src="assets/images/close.svg" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close()">
    </div>
    <form class="width100" [formGroup]="GraphConfigform">
        <div class="container-data56 popup-inner-space mt-3">
            <div class="errmsg " *ngIf="errorMsg">{{errorMsg}}</div>
            <div class="errmsg" *ngIf="registeraddtion">
                Few Register details already exists Please check info..
                <span class="info-icon-container" (mouseover)="showTooltip = true" (mouseleave)="showTooltip = false">
                    <span class="info-icon">
                        &#9432;
                    </span>
                </span>
                <div *ngIf="showTooltip" class="tooltip-content">
                    {{registeraddtion}}
                </div>
            </div>

            <div class="sucessmsg error-fix" *ngIf="successMsg">{{successMsg}}</div>
        </div>
        <div class="row marginleftright0">
            <div class="col-sm-3 col-md-3 col-lg-3 mb-2 padding-left-10 padding-right-0">
                <div class="fxg-field fxg-field2">
                    <input formControlName="GraphConfigName" id="GraphConfigName" type="text"
                        class="fxg-field__input-text fxg-field__input--required sessioncamexclude">
                    <span class="fxg-field__placeholder fxg-field__floating-placeholder custom-placeholder"
                        tabindex="-1">Custom Report Name</span>
                    <div class="error_msg" *ngIf="displayMessage.GraphConfigName">
                        {{displayMessage.GraphConfigName}}
                    </div>
                </div>
            </div>
            <div class="col-lg-3 paddingleftright5">
                <div class="fxg-field fxg-field2">
                    <label class="Navuser" id="Company-Name">Meter Name
                    </label>
                    <mat-form-field style="display:block;" title="Meter Name">

                        <mat-select formControlName="MeterId" (selectionChange)="OnChangeEnergymeter($event)" multiple>
                            <mat-option value="">(Select Meter Name)</mat-option>
                            <mat-option MatFormFieldControl="MeterId" *ngFor="let lstenergymeter of EnergyMeterList"
                                [value]="lstenergymeter.CodeValue">
                                {{lstenergymeter.CodeDisplayText}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="error_msg" *ngIf="displayMessage.MeterId">{{displayMessage.MeterId}}</span>
                </div>
            </div>
            <div class="col-lg-3 paddingleftright5">
                <div class="fxg-field fxg-field2">
                    <mat-form-field style="display:block;" title="Register Name">
                        <mat-select formControlName="RegisterDataId" (selectionChange)="OnChangeRegisterName($event)"
                            multiple>
                            <mat-option value="" *ngIf="!isSelectionMade">(Select Register Name)</mat-option>
                            <mat-option MatFormFieldControl="RegisterDataId"
                                *ngFor="let lstregister of mainregisterlist" value="{{lstregister.RegisterDataId}}">
                                {{lstregister.RegisterName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="error_msg"
                        *ngIf="displayMessage.RegisterDataId">{{displayMessage.RegisterDataId}}</span>
                </div>
            </div>
            <div class="col-lg-3 paddingleftright5">
                <div class="fxg-field fxg-field2">
                    <mat-form-field style="display:block;" title="Data Type">
                        <mat-select formControlName="DataType" (selectionChange)="OnChangeDataType($event.value)">
                            <mat-option value="" MatFormFieldControl="DataType">(Select Data Type)</mat-option>
                            <mat-option value="Average">Average</mat-option>
                            <mat-option value="Total">Total</mat-option>
                            <mat-option value="Current">Current</mat-option>
                            <mat-option value="Consumption">Consumption Report</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="error_msg" *ngIf="displayMessage.DataType">{{displayMessage.DataType}}</span>
                </div>
            </div>
            <div class="col-lg-3 paddingleftright5 margin-top-5">
                <div class="fxg-field fxg-field2">
                    <mat-form-field style="display:block;" title="Grand Total Type">
                        <mat-select formControlName="isShowTotal" (selectionChange)="OnChangeTotalType($event.value)">
                            <mat-option value="" MatFormFieldControl="isShowTotal">(Select Total Type)</mat-option>
                            <mat-option MatFormFieldControl="isShowTotal" *ngFor="let totaltype of grandTotalTypeslist"
                                value="{{totaltype.CodeValue}}">
                                {{totaltype.CodeDisplayName}}
                            </mat-option>

                        </mat-select>
                    </mat-form-field>
                    <span class="error_msg" *ngIf="displayMessage.isShowTotal">{{displayMessage.isShowTotal}}</span>
                </div>
            </div>
            <div class="col-lg-3 paddingleftright15 d-flex margin-top-5">
                <button class="btncommon search-usermater" id="SearchusermasterSearch"
                    (click)="AddRegisters()">Add</button>
            </div>
        </div>
        <div class="table-scroll-newsite tableBR margin-left-5">
            <table class="table table-layout-fixed">
                <thead class="companytable thead-data td-data-main">
                    <tr class="tr-padding">
                        <th class="width-10">No.</th>
                        <th class="width-25">Meter Name</th>
                        <th class="text-right"></th>
                        <th class="width-25">Register Name</th>
                        <th class="width-20">Data Type</th>
                        <th class="width-20" *ngIf="selectedtotaltype==1 || selectedtotaltype==3">Column Total</th>
                        <th class="width10 text-right">Action</th>
                    </tr>
                </thead>
                <tbody clas="table-responsive-sechedule">
                    <tr *ngFor="let data of ParameterList; let i = index">
                        <td class="width-10">{{i+1}}</td>
                        <td class="width-25">{{data.MeterName}}</td>
                        <th class="text-right"></th>
                        <td class="width-25">{{data.RegisterName}}</td>
                        <td class="width-25">{{data.DataType}}</td>
                        <td class="" *ngIf="selectedtotaltype==1 || selectedtotaltype==3">
                            <input type="checkbox" [checked]="data.ColumnTotal"
                                (change)="onCheckboxChange(data, $event.target.checked)">
                        </td>
                        <td class="width10 text-right"><img src="assets/images/delete.svg" alt="..."
                                class="img-fluid closeicon2 cursor-pointer" (click)="DeleteGraphConfigData(i)"
                                id="delete_icon">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row marginleftright0 margin-top-5 d-flex justify-content-end">
            <div class="col-lg-3 paddingleftright180 text-right padding-right-2">
                <button type="submit" class="btncommon search-usermater" id="SearchusermasterSearch"
                    [ngClass]="{'btncommon-hoverreportconfig': reportconfigbutton}" [disabled]="reportconfigbutton"
                    (click)="OpenReportSettings()">Report Settings</button>
            </div>
            <div class="col-lg-3  text-right padding-left-5">
                <button type="submit" class="btncommon search-usermater" id="SearchusermasterSearch"
                    (click)="SaveParameterConfigData()">Save</button>
            </div>
        </div>
    </form>
</div>